import dynamic from "next/dynamic";
import styled from "styled-components";

const SocialIcons = dynamic(() => import("@/common/Header/socialIcon"));
const LinkUI = dynamic(() => import("@/common/UI/Link"));

import { getHeaderMenuSlug } from "@/utils/functions";

const MenuItem = (props) => {
  const {
    menu,
    customClass,
    linkClass,
    contactBtn,
    socialIcon,
    siteConfig,
    closeMenu,
    labelsList,
    contactText,
    menuList,
  } = props;

  const HoverBG = styled.div`
    button {
      &:hover {
        background: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        background: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  const HoverLink = styled.p`
    a {
      &:hover {
        color: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        color: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  const HoverLinkbtn = styled.div`
    button {
      &:hover {
        color: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        color: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  return (
    <>
      <>
        <ul className={customClass ? customClass : ""}>
          {menu?.map((item, index) => {
            return item?.title ? (
              <HoverLink key={index}>
                {/* sc-iIUQWv bEFSId */}
                <LinkUI
                  href={getHeaderMenuSlug(item)}
                  className={linkClass}
                  onClick={() => closeMenu()}
                >
                  {item?.title}
                </LinkUI>
              </HoverLink>
            ) : null;
          })}

          {contactText && (
            <>
              <HoverLink>
                <LinkUI
                  href={`/offerta/[slug]/[typology]`}
                  as={`/offerta/corsi/${menuList?.onlinePremise?.slug}`}
                  className={linkClass}
                  onClick={() => closeMenu()}
                >
                  {menuList?.onlinePremise?.title}
                </LinkUI>
              </HoverLink>
              <HoverLinkbtn>
                <button
                  className={`${linkClass} w-full text-right`}
                  data-tf-slider={siteConfig?.typeformId}
                  data-tf-width="450"
                  data-tf-medium="snippet"
                  onClick={() => closeMenu("form")}
                >
                  {labelsList?.contactUs}
                </button>
              </HoverLinkbtn>
            </>
          )}

          {/* {contactBtn && (
           <li className="pl-4 uppercase h6-web tracking-widest font-black ">
             <HoverBG id="openGeneralPopup">
               <a
                 href={siteConfig?.typeform}
                 target={"_blank"}
                 style={{
                   backgroundColor: siteConfig?.brandButtonDefaultColor?.hex,
                   border: siteConfig?.brandButtonHoverColor?.hex,
                 }}
                 className="font-black h6-web rounded-full tracking-wider px-6 py-3 text-white  border"
                 rel="noreferrer"
               >
                 {labelsList?.contactUs}
               </a>
             </HoverBG>
           </li>
         )} */}
          {contactBtn && (
            <li className="uppercase h6-web tracking-widest font-black">
              <HoverBG>
                <LinkUI
                  href={`/offerta/[slug]/[typology]`}
                  as={`/offerta/corsi/${menuList?.onlinePremise?.slug}`}
                >
                  <button
                    className="bg-theme font-black h6-web rounded-full tracking-widest px-6 py-3 text-white  border uppercase"
                    style={{
                      backgroundColor: siteConfig?.brandButtonDefaultColor?.hex,
                      border: siteConfig?.brandButtonHoverColor?.hex,
                    }}
                  >
                    {menuList?.onlinePremise?.title}
                  </button>
                </LinkUI>
              </HoverBG>
            </li>
          )}
          {contactBtn && siteConfig?.typeformId && labelsList && (
            <li className="pl-4 uppercase h6-web tracking-widest font-black ">
              <button
                data-tf-slider={siteConfig?.typeformId}
                data-tf-width="550"
                data-tf-medium="snippet"
                // style={{
                //   color: siteConfig?.brandButtonDefaultColor?.hex,
                //   border: siteConfig?.brandButtonHoverColor?.hex,
                // }}
                className="bg-white text-theme font-black h6-web rounded-full tracking-widest px-6 py-3   border-2"
              >
                {labelsList?.contactUs}
              </button>
            </li>
          )}

          {socialIcon && <SocialIcons siteConfig={siteConfig} />}
        </ul>
      </>
    </>
  );
};

export default MenuItem;
